import getWindowScroll from "./auth-service-tools1233.js";
import getWindow from "./auth-service-tools1160.js";
import { isHTMLElement } from "./auth-service-tools1025.js";
import getHTMLElementScroll from "./auth-service-tools1234.js";

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

export { getNodeScroll as default };